import {AccountFieldsPrefix, withPrefix} from '@/constants/prv-comp';
import {DocumentData} from '@/engine';
import {AccountPacInvestmentInstructions, DetailedInvestorAccount} from '@/types/client-info';
import {COMP_TO_PAC_MAPPINGS} from './comp-to-pac-mappings';

const getFreshPacInstructions = (pac: DetailedInvestorAccount['pac']): AccountPacInvestmentInstructions | null =>
  pac?.length === 1 ? pac[0].investmentInstructions : null;

export const detectRemovedPacs = (
  storeData: DocumentData['data'],
  freshAccount: DetailedInvestorAccount,
  prefix: AccountFieldsPrefix,
): string[] => {
  const removedFundCodes = new Set<string>();
  const freshInstructions = getFreshPacInstructions(freshAccount.pac);

  COMP_TO_PAC_MAPPINGS.forEach(({compKeyField, investmentType, getKey}) => {
    const keyField = withPrefix(compKeyField, prefix);
    const freshKeys = new Set((freshInstructions?.[investmentType] ?? []).map(getKey));
    const oldKeyPattern = new RegExp(`^${keyField}#\\d+$`);

    Object.entries(storeData).forEach(([key, value]) => {
      if (!oldKeyPattern.test(key) || typeof value !== 'string') return;

      if (!freshKeys.has(value)) {
        removedFundCodes.add(value);
      }
    });
  });

  return Array.from(removedFundCodes);
};
